import React, { useEffect, useRef, useState } from 'react';
import { AppMultiselect, AppSelectItemProp } from '../../../components/molecules/AppMultiselect/AppMultiselect';

export interface SelectProps {
  label: string;
  value: string;
}

export interface CountryCriteriaFormState {
  selectedCountries: AppSelectItemProp[];
}

interface CountryCriteriaFormProps {
  countries: SelectProps[];
  value?: CountryCriteriaFormState;
  onChange: (e: CountryCriteriaFormState) => void;
}

export const CountryCriteriaForm = ({
  countries,
  value,
  onChange,
}: CountryCriteriaFormProps) => {
  const resolveLabels = (state: CountryCriteriaFormState): CountryCriteriaFormState => ({
    selectedCountries: state.selectedCountries.map((item) => {
      const match = countries.find((c) => c.value === item.value);
      return match ? { label: match.label, value: item.value } : item;
    }),
  });

  const [formState, setFormState] = useState<CountryCriteriaFormState>(
    value ? resolveLabels(value) : { selectedCountries: [] },
  );

  // Clave del value prop para detectar cambios reales sin comparar referencias
  const valueKey = value?.selectedCountries.map(c => c.value).sort().join(',') ?? '';
  const prevValueKeyRef = useRef('');

  // Sincroniza solo cuando el contenido del value prop cambia externamente
  // (ej: datos cargados del API al editar). No depende de `formState` para
  // evitar el loop: onChange → padre actualiza value → setFormState → onChange
  useEffect(() => {
    if (valueKey !== prevValueKeyRef.current) {
      prevValueKeyRef.current = valueKey;
      if (value) {
        const resolved = resolveLabels(value);
        setFormState(resolved);
        onChange(resolved);
      }
    }
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  }, [valueKey, countries]);

  const handleChange = (selected: AppSelectItemProp[]) => {
    const newState = { selectedCountries: selected };
    setFormState(newState);
    onChange(newState);
  };

  return (
    <div className="w-[275px]" data-testid="country-criteria-form">
      <label className="flex flex-col text-left text-sm text-shark-800 w-full">
        Pais
        <div className="mt-1">
          <AppMultiselect
            isSearchable
            options={countries}
            value={formState.selectedCountries}
            onChange={handleChange}
          />
        </div>
      </label>
    </div>
  );
};

export default CountryCriteriaForm;
